<template>
  <div
    id="menu-container"
    class="d-flex justify-between w-100 c-gray f-graphit c-graphit"
  >
    <div
      v-if="$vuetify.display.smAndDown"
      class="d-flex brand-logo justify-center align-center flex-grow-1 px-1"
      itemscope
      itemtype="https://schema.org/Brand"
    >
      <a href="/" class="d-flex w-100" @click.prevent="goToHome">
        <VImg
          :src="logoSrc"
          :aspect-ratio="logoAspectRatio"
          max-height="30"
          alt="vicampo-logo"
        />
      </a>
    </div>
    <div class="px-2">
      <ProfileNavigation />
    </div>
    <TheHeaderWishlist class="d-flex flex-grow-0 px-2" />
    <TheHeaderCart class="d-flex flex-grow-0 px-2" />
  </div>
</template>

<script>
import logoMain from '@/assets/images/logo-main.svg'
import ProfileNavigation from '@/components/basic/atoms/ProfileNavigation.vue'
import TheHeaderCart from '@/components/basic/molecules/TheHeaderCart.vue'
import TheHeaderWishlist from '@/components/basic/molecules/TheHeaderWishlist.vue'
import { LOGO_MAIN_ASPECT_RATIO } from '@/constants/GlobalConstants.js'
import { VImg } from 'vuetify/components'

export default {
  components: {
    VImg,
    ProfileNavigation,
    TheHeaderCart,
    TheHeaderWishlist
  },
  computed: {
    logoAspectRatio() {
      return LOGO_MAIN_ASPECT_RATIO
    },
    logoSrc() {
      return logoMain
    }
  },
  methods: {
    goToHome() {
      this.$route.path !== '/' ? this.$router.push('/') : this.$router.go('/')
    }
  }
}
</script>

<style scoped>
#menu-container {
  cursor: pointer;
  height: 50px;
  background-color: rgb(var(--v-theme-white));
  border-top: 1px solid rgb(var(--v-theme-light-ochre));
  border-bottom: 1px solid rgb(var(--v-theme-light-ochre));
}

/* A media query, not the .display-md-and-up class: that class comes from a
   JS breakpoint that server renders don't know (they default to xs), so a
   class-gated rule paints the mobile borders on desktop until hydration
   catches up (VIP-12038). 960px = Vuetify's md threshold. */
@media (min-width: 960px) {
  #menu-container {
    background-color: transparent;
    border: none;
    height: 75px;
  }
}
</style>
